'use strict'

import $ from 'jquery';

const videoLiftUp = {

  $currentVideoPlaceholder: null,

  playVideo($container){
    var video = $container.find('video').get(0);
    var $videpPlaceholder = $container.find('.element-video-lift-up__video-placeholder');
    $container.find('[aria-expanded]').attr('aria-expanded','true');
    $videpPlaceholder.css('display', 'block');
    $container.find('[data-video-lift-up-hide]').get(0).focus();

    if(video){
      video.play();
    }
  },

  hideVideo($container){
    var video = $container.find('video').get(0);
    var $videpPlaceholder = $container.find('.element-video-lift-up__video-placeholder');
    if(video){
      video.pause();
    }
    $container.find('[data-video-lift-up-play]').get(0).focus();
    $container.find('[aria-expanded]').attr('aria-expanded','false');
    $videpPlaceholder.css('display', 'none');
  },

  init(){
    const self = this;

    $('[data-video-lift-up-play]').on('click', function(){
      let $container = $(this).closest('.element-video-lift-up');
      self.playVideo($container);
    });

    $('[data-video-lift-up-hide]').on('click', function(){
      let $container = $(this).closest('.element-video-lift-up');
      self.hideVideo($container);
    });
  }
}

module.exports = videoLiftUp;
